import { Box, Stack } from '@mui/material'
import { useAction } from '../../containers/facilityLotteryReservationUpdateSelection/facilityLotteryReservationUpdateSelectionService';
import { yesNo } from '../../containers/common/constant/classification'
import { translate } from '../../i18n'
import { AnnotationLabel } from '../components/common/annotationLabel'
import { GContainer, GItem } from '../components/common/grids'
import { AvailabilityCalendar } from '../components/common/inputs/availabilityCalendar'
import { Form } from '../components/common/inputs/form'
import ChildName from '../components/common/reservationFlow/selection/childName'
import BottomButtons from '../components/common/reservationFlow/selection/bottomButtons'
import DateSelection from '../components/common/reservationFlow/selection/dateSelection'
import FacilityLinkedName from '../components/common/reservationFlow/selection/facilityLinkedName'
import FacilityNoteCard from '../components/common/reservationFlow/selection/facilityNote'
import ReservationStepBar, { RESERVATION_STEPS } from '../components/common/reservationFlow/reservationStepBar'
import UseReasonSelection from '../components/common/reservationFlow/selection/useReasonSelection'

export const FacilityLotteryReservationUpdateSelection = () => {
  const {
    state,
    previousRange,
    methods,
    purposeOfUse,
    useReasonDetailIrregular,
    useReasonDetailEmg,
    useReasonDetailRefresh,
    onSubmit,
    changeDate,
    onChangeUseReason,
  } = useAction();
  
  if (!state) {
    return null;
  }

  return (
    <Form onSubmit={onSubmit} formMethods={methods}>
      <Stack spacing={1}>
        <GContainer>
          <GItem md={3}></GItem>
          <GItem xs={12} md={6}>
            <Box>
              <GContainer rowSpacing={1}>
                <GItem xs={12}>
                  <ReservationStepBar activeStepValue={RESERVATION_STEPS.SELECTION}/>
                </GItem>
  
                <GItem xs={12}>
                  <FacilityLinkedName 
                    facilityId={state.prevReservation.facilityId}
                    facilityName={state.prevReservation.facilityName}
                  />
                </GItem>
  
                <GItem xs={12}>
                  <ChildName childName={state.selectedChildName} />
                  {
                    state.commonFlag === yesNo.no 
                    && Object.values(state.useReasonOptions).some((usage) => usage)
                    && (
                      <UseReasonSelection
                        useReason={state.useReason}
                        useReasonOptions={state.useReasonOptions}
                        facility={state.facility}
                        purposeOfUse={purposeOfUse?? ''}
                        useReasonDetailIrregular={useReasonDetailIrregular?? ''}
                        useReasonDetailEmg={useReasonDetailEmg?? ''}
                        useReasonDetailRefresh={useReasonDetailRefresh?? ''}
                        onChange={onChangeUseReason}
                        setValue={methods.setValue}
                      />
                    )
                  }
                  <DateSelection activeDate={state.activeDate} onChange={changeDate} />
                </GItem>
  
                <GItem xs={12}>
                  <Stack spacing={2}>
                    <AnnotationLabel>{translate(state.usageGuideStr)}</AnnotationLabel>
  
                    <AvailabilityCalendar
                      name="usageDesiredDatetimes"
                      label={translate('facilityLotteryReservationUpdateSelection.label.availabilityCalendar')}
                      required
                      baseDate={state.activeDate}
                      previousRange={previousRange}
                      isLottery={true}
                      receptionTimePattern={state.facility.receptionTimePattern}
                      availabilities={state.availabilities ?? []}
                      isMultiple={false}
                      onChangeBaseDate={changeDate}
                      control={methods.control}
                      trigger={methods.trigger}
                      receptionTimeName={state.facility.receptionTimeName}
                    />
                  </Stack>
                </GItem>
                <GItem xs={12}>
                  {
                    state.lotteryNote && (
                      <FacilityNoteCard>{state.lotteryNote}</FacilityNoteCard>
                    )
                  }
                </GItem>
                {
                  state.commonFlag === yesNo.yes 
                  && Object.values(state.useReasonOptions).some((usage) => usage)
                  && (
                    <GItem xs={12}>
                      <UseReasonSelection
                        useReason={state.useReason}
                        useReasonOptions={state.useReasonOptions}
                        facility={state.facility}
                        purposeOfUse={purposeOfUse?? ''}
                        useReasonDetailIrregular={useReasonDetailIrregular?? ''}
                        useReasonDetailEmg={useReasonDetailEmg?? ''}
                        useReasonDetailRefresh={useReasonDetailRefresh?? ''}
                        onChange={onChangeUseReason}
                        setValue={methods.setValue}
                      />
                    </GItem>
                  )
                }
              </GContainer>
            </Box>
          </GItem>
          <GItem md={3}></GItem>
        </GContainer>
  
        <BottomButtons />
      </Stack> 
    </Form>
  )
}